import React from 'react'
import styled from 'styled-components'
import Footer from '../Footer'

const Screen = styled.div`
min-height: 100vh;
display: flex;
justify-content: center;
`

const ScreenContentContainerInner = styled.div`
max-width: 640px;
margin: 0;
margin-bottom: 30px;
padding: 0 20px;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
@media(max-width: 1111px) {
  max-width: minmax(100vw, 640px);
}
`

const ScreenContentContainer = props => {
  return (
    <ScreenContentContainerInner>
    {props.children}
    <Footer />
    </ScreenContentContainerInner>
  )
}

const StandardScreen = props => {
  return <Screen><ScreenContentContainer>{props.children}</ScreenContentContainer></Screen>
}

export default Screen
export { ScreenContentContainer, StandardScreen }


// WEBPACK FOOTER //
// ./src/App/Page/Screen.js